import React from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import { AboutGallery } from './AboutGallery';

export const About = () => (
  <section id="about" className="section-space about-section" aria-labelledby="about-heading" data-testid="about-section">
    <div className="site-container about-grid">
      <figure className="about-image" data-testid="about-image-block">
        <AboutGallery />
        <figcaption data-testid="about-image-caption"><span>Precisão nos detalhes.<br /><strong>Confiança em cada andar.</strong></span></figcaption>
      </figure>
      <div className="about-copy">
        <h2 className="section-kicker" id="about-heading">SOBRE A FATT</h2>
        <p className="section-title" data-testid="about-title">Elevamos espaços.<br />Conectamos pessoas.</p>
        <p>Somos especialistas em transporte vertical. Unimos conhecimento técnico, cuidado com as pessoas e atenção à arquitetura para entregar a solução certa para cada projeto.</p>
        <p data-testid="about-experience">Nossa equipe reúne <strong>mais de 10 anos de experiência</strong> e capacitação em <strong>NR10 e NR12</strong>. Com atuação nacional, estamos presentes da escolha do equipamento à instalação e à manutenção.</p>
        <div className="about-values" data-testid="about-values">
          {['Segurança e eficiência', 'Conforto em cada percurso', 'Compromisso com a pontualidade', 'Excelência no acabamento'].map((value, index) => <span key={value} data-testid={`about-value-${index}`}><Check size={17} />{value}</span>)}
        </div>
        <a href="#contact" className="text-link" data-testid="about-contact">Conte seu projeto para a gente <ArrowUpRight size={19} /></a>
      </div>
    </div>
  </section>
);